export const DashboardAvailable = {
  title: 'Pedidos Disponíveis'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/DashboardAvailable.js